import api from "./api";

const StorageService = {

  clearLoginData: () => {
    localStorage.removeItem("employeeId");
    localStorage.removeItem("firstName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("empCompanyId");
    localStorage.removeItem("empRoleId");
    localStorage.removeItem("empRoleName");
    localStorage.removeItem("empEmailId");
  },
  setLoginData: (user) => {
    localStorage.setItem("employeeId", user.id);
    localStorage.setItem("firstName", user.firstName);
    localStorage.setItem("lastName", user.lastName);
    localStorage.setItem("empCompanyId", user.companyId);
    localStorage.setItem("empRoleId", user.roleId);
    localStorage.setItem("empRoleName", user.roleName);
    localStorage.setItem("empEmailId", user.emailId);
  },
  loginData: () => {
    const employeeId = localStorage.getItem("employeeId");
    if (!employeeId) return null;
    return {
      employeeId,
      // employeeId: localStorage.getItem("employeeId"),
      firstName: localStorage.getItem("firstName"),
      lastName: localStorage.getItem("lastName"),
      companyId: localStorage.getItem("empCompanyId"),
      roleId: localStorage.getItem("empRoleId"),
      roleName: localStorage.getItem("empRoleName"),
      emailId: localStorage.getItem("empEmailId")
    }
  }
};

export default StorageService;
